export enum BannerCategory {
  HUB_1 = 'HUB_1',
  HUB_2 = 'HUB_2',
  HUB_3 = 'HUB_3',
  HUB_4 = 'HUB_4',
  HUB_5 = 'HUB_5',
  HUB_6 = 'HUB_6',
  HUB_7 = 'HUB_7',
  STORE_1 = 'STORE_1',
  STORE_2 = 'STORE_2',
  STORE_3 = 'STORE_3',
  STORE_4 = 'STORE_4',
  STORE_5 = 'STORE_5',
  STORE_6 = 'STORE_6',
  STORE_7 = 'STORE_7',
  STORE_8 = 'STORE_8',
  STORE_9 = 'STORE_9',
  STORE_10 = 'STORE_10',
  STORE_ONSITE_1 = 'STORE_ONSITE_1',
  STORE_ONSITE_2 = 'STORE_ONSITE_2',
  STORE_ONSITE_3 = 'STORE_ONSITE_3',
  STORE_ONSITE_4 = 'STORE_ONSITE_4',
}
